import React, { useState } from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';

export default function PasswordInput({ value, onChange, placeholder, name, className = '', ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className="password-input-wrapper">
      <input
        type={show ? 'text' : 'password'}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`form-input-modal password-input ${className}`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow(!show)}
        className="password-toggle"
      >
        {show ? (
          <AiOutlineEyeInvisible className="eye-icon" />
        ) : (
          <AiOutlineEye className="eye-icon" />
        )}
      </button>
    </div>
  );
}
